module.exports = __webpack_public_path__ + "static/media/github.45e39d93.svg";